__turbopack_context__.v({
  "isScrollBottomButtonHidden": "WhereToGoSectionMapPanel-module__TB7XKW__isScrollBottomButtonHidden",
  "isSelected": "WhereToGoSectionMapPanel-module__TB7XKW__isSelected",
  "mapPanel": "WhereToGoSectionMapPanel-module__TB7XKW__mapPanel",
  "region": "WhereToGoSectionMapPanel-module__TB7XKW__region",
  "scrollBottomButton": "WhereToGoSectionMapPanel-module__TB7XKW__scrollBottomButton",
  "scrollWrapper": "WhereToGoSectionMapPanel-module__TB7XKW__scrollWrapper",
  "title": "WhereToGoSectionMapPanel-module__TB7XKW__title",
});
